export default __webpack_public_path__ + "static/media/logo.fa811a55.svg";